// client/src/components/guards/TenantUnitGuard.tsx
// 868mbzt38 — D1 (renter-portal anti-cycle). Mirrors OwnerUnitGuard:
// latches the units query and exposes the stable Retry notice path.

import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { PageSkeleton } from '@/components/PageSkeleton';
import { QueryErrorState } from '@/components/ui/QueryErrorState';
import { useTenantUnit } from '@/contexts/TenantUnitContext';

export function TenantUnitGuard({ children }: { children: React.ReactNode }) {
  const [location, setLocation] = useLocation();
  const { allUnits, isLoading, hasUserSelected, loadError, isRetrying, retry } =
    useTenantUnit();

  const needsSelection =
    !isLoading &&
    allUnits.length > 1 &&
    !hasUserSelected;

  useEffect(() => {
    if (needsSelection && location !== '/unit-select') {
      setLocation('/unit-select');
    }
  }, [needsSelection, location, setLocation]);

  if (loadError !== null) {
    return (
      <div
        data-testid="tenant-unit-load-error"
        className="flex flex-col items-center justify-center gap-3 py-16"
      >
        <QueryErrorState
          error={loadError}
          isRetrying={isRetrying}
          onRetry={retry}
        />
      </div>
    );
  }

  if (isLoading) {
    return <PageSkeleton />;
  }

  if (needsSelection && location !== '/unit-select') {
    return <PageSkeleton />;
  }

  return <>{children}</>;
}
